import axios from '../../../axios/index';

export default {
    createUpdateReport (data, revisionId = null, completed = false) {
        let formData = new FormData();

        formData.append('completed', completed ? '1' : '0');

        formData.append('actual_duration_hours', data.actual_duration_hours);
        if (data.attachments.length) {
            data.attachments.forEach((attachment, index) => {
                formData.append('attachments[' + index + ']', JSON.stringify(attachment.file));
            });
        } else {
            formData.append('attachments[]', null);
        }
        let checklist = [];
        data.checklist.forEach(classification => {
            if (classification.items.length) {
                classification.items.forEach(item => {
                    let itemData = {};
                    if (item.id) {
                        itemData.id = item.id;
                    }
                    itemData.classification = classification.name;
                    itemData.item = item.name;
                    itemData.value = item.value ? item.value : null;
                    checklist.push(JSON.stringify(itemData));
                });
            }
        });
        formData.append('checklist', JSON.stringify(checklist));

        if (!data.id) {
            return axios.post('/api/v1/shop-drawings/cross-checking-report/' + revisionId, formData);
        }

        return axios.post('/api/v1/shop-drawings/cross-checking-report/' + revisionId + '/' + data.id, formData);
    },

    getReport (revisionId) {
        return axios.get('/api/v1/shop-drawings/cross-checking-report/creation-data/' + revisionId);
    },
    getCreationData () {
        return axios.get('/api/v1/shop-drawings/cross-checking-report/creation-data/');
    },
    getFileUploadUrl (projectId, fileName) {
        return axios.get('/api/v1/shop-drawings/cross-checking-report/file-upload-url', {
            params: {
                file_name: fileName,
                project_id: projectId,
            },
        });
    },
};
